module.exports = __webpack_public_path__ + "media/images/web/profesor-156d33ca13249dde6919dc0dcf807245.jpg";